import { combineReducers } from 'redux';
import undoable from 'redux-undo';
import ConfigReducer from 'rtk/ConfigSlice';
import LayoutControlSlice from 'rtk/layout/LayoutControlSlice';
import LibrarySlice from 'rtk/LibrarySlice';
import TemplateSlice from 'rtk/TemplateSlice';

// APIs
import { themesApi } from '@/themes';
import { adminsApi } from 'rtk/query/apis/admins';
import { applicationsApi } from 'rtk/query/apis/applications';
import { brevoApi } from 'rtk/query/apis/brevo';
import { candidatesApi } from 'rtk/query/apis/candidates';
import { clientsApi } from 'rtk/query/apis/clients';
import { interviewsApi } from 'rtk/query/apis/interviews';
import { jobsApi } from 'rtk/query/apis/jobs';
import { mediaApi } from 'rtk/query/apis/media';
import { miscApi } from 'rtk/query/apis/misc';
import { notificationsApi } from 'rtk/query/apis/notifications';
import { questionsApi } from 'rtk/query/apis/questions';
import { scoresApi } from 'rtk/query/apis/scores';
import { templateCommentsApi } from 'rtk/query/apis/templateComments';
import { templatesApi } from 'rtk/query/apis/templates';
import QuestionEditorSlice from 'rtk/Question.Editor.Slice';

import { agentChatApi } from 'rtk/query/apis/chat';
import { outreachApi } from 'rtk/query/apis/outreach';
import { outreachCandidatesApi } from 'rtk/query/apis/outreachCandidates';
import { voiceConversationApi } from 'rtk/query/apis/voiceConversation/index.ts';
import QuestionSlice from 'rtk/QuestionSlice';
const appReducers = combineReducers({
  // Test:       undoable(TestReducer),
  config: ConfigReducer,
  Layout: LayoutControlSlice,
  Template: undoable(TemplateSlice),
  Library: LibrarySlice,
  Question: QuestionSlice,
  // Parameters: ParameterSlice,
  [adminsApi.reducerPath]: adminsApi.reducer,
  [templatesApi.reducerPath]: templatesApi.reducer,
  [clientsApi.reducerPath]: clientsApi.reducer,
  [agentChatApi.reducerPath]: agentChatApi.reducer,
  [questionsApi.reducerPath]: questionsApi.reducer,
  [miscApi.reducerPath]: miscApi.reducer,
  [interviewsApi.reducerPath]: interviewsApi.reducer,
  [jobsApi.reducerPath]: jobsApi.reducer,
  [applicationsApi.reducerPath]: applicationsApi.reducer,
  [brevoApi.reducerPath]: brevoApi.reducer,
  [scoresApi.reducerPath]: scoresApi.reducer,
  [candidatesApi.reducerPath]: candidatesApi.reducer,
  [outreachApi.reducerPath]: outreachApi.reducer,
  [outreachCandidatesApi.reducerPath]: outreachCandidatesApi.reducer,
  [voiceConversationApi.reducerPath]: voiceConversationApi.reducer,
  [notificationsApi.reducerPath]: notificationsApi.reducer,
  [templateCommentsApi.reducerPath]: templateCommentsApi.reducer,
  [mediaApi.reducerPath]: mediaApi.reducer,
  [themesApi.reducerPath]: themesApi.reducer,
  questionEditor: QuestionEditorSlice,
});

export default appReducers;
